/* Copyright Information: Created by BuyGroup */
import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap";

/**
 * Reusable Confirmation Modal Component
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Controls modal visibility
 * @param {Function} props.onClose - Function to call when modal is closed
 * @param {string} props.title - Modal title
 * @param {string|ReactNode} props.content - Modal content (text or JSX)
 * @param {Object} props.primaryAction - Primary button configuration
 * @param {string} props.primaryAction.label - Primary button label
 * @param {Function} props.primaryAction.onClick - Primary button click handler
 * @param {string} props.primaryAction.color - Primary button color (default: "primary")
 * @param {boolean} props.primaryAction.loading - Show loading state on primary button
 * @param {Object} props.secondaryAction - Secondary button configuration
 * @param {string} props.secondaryAction.label - Secondary button label
 * @param {Function} props.secondaryAction.onClick - Secondary button click handler
 * @param {string} props.secondaryAction.color - Secondary button color (default: "secondary")
 * @param {boolean} props.secondaryAction.loading - Show loading state on secondary button
 * @param {string} props.size - Modal size ("sm", "lg", "xl" or undefined for default)
 * @param {boolean} props.centered - Center modal vertically (default: true)
 */
const ConfirmationModal = ({
  isOpen,
  onClose,
  title = "Confirmation",
  content = "Are you sure you want to proceed?",
  primaryAction,
  secondaryAction,
  size,
  centered = true,
}) => {
  const handlePrimaryClick = () => {
    if (primaryAction?.onClick) {
      primaryAction.onClick();
    }
  };

  const handleSecondaryClick = () => {
    if (secondaryAction?.onClick) {
      secondaryAction.onClick();
    } else {
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered={centered} size={size}>
      <ModalHeader toggle={onClose}>{title}</ModalHeader>
      <ModalBody>{content}</ModalBody>
      <ModalFooter>
        {secondaryAction && (
          <Button
            color={secondaryAction.color || "secondary"}
            onClick={handleSecondaryClick}
            disabled={secondaryAction.loading || primaryAction?.loading}
            style={{ minWidth: "120px" }}
          >
            {secondaryAction.loading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              secondaryAction.label || "Cancel"
            )}
          </Button>
        )}
        {primaryAction && (
          <Button
            color={primaryAction.color || "primary"}
            onClick={handlePrimaryClick}
            disabled={primaryAction.loading || secondaryAction?.loading}
            style={{ minWidth: "120px" }}
          >
            {primaryAction.loading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              primaryAction.label || "Confirm"
            )}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmationModal;
/* Copyright Information: Created by BuyGroup */
